/* IE 11 polyfill */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
/**/

import { createRoot } from "react-dom/client";
import App from "./App";
import { HashRouter as Router } from "react-router-dom";
/*STYLE GLOBAL*/
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import "./index.css";
/**/
/** init jquery + bootstrap + polyfill globally */
import $ from "jquery";
window.$ = window.jQuery = $;
require("bootstrap");
/**/
/**
 * Fonction utilisée dans la page définition (hkc_definitions_xx.php)
 * @param {*} id_div Id de l'élément à afficher/cacher
 */
window.toggleDiv = function (id_div) {
  $(`#${id_div}`).toggleClass("hidden");
};
const container = document.getElementById("react-container");
const root = createRoot(container);
root.render(
  <Router>
    <App />
  </Router>
);
